import { render, staticRenderFns } from "./QuantityInput.vue?vue&type=template&id=1896b5da&"
import script from "./QuantityInputVue.ts?vue&type=script&lang=ts&"
export * from "./QuantityInputVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports